<template>
  <v-container>
    <div class="quota-allocation-pg">
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg"> {{ $t('Лимиты') }}</h1>
      <div class="my-organization">
        <div class="quotas-pg quota-limits bgw-pdg-20">
          <div class="flex-two-col">
            <div class="flex-two-col__left">
              <Menu />
            </div>
          </div>
          <div class="flex-two-col">
            <div class="flex-two-col__left">
              <ul class="list-column">
                <li v-for="(year, i) in refYear" :class="{ active: year.id === yearId }" :key="i">
                  <a href="#" @click="changeYear(year.id)">{{ year.year }}</a>
                </li>
              </ul>
            </div>
            <div class="flex-two-col__right">
              <ul class="list-column">
                <li>
                  <a href="#">{{ $t('Печать лимита') }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="search-head">
            <v-row>
              <v-col>
                <v-label>{{ $t('Тип организации') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="ooptTypes"
                    item-value="id"
                    item-text="transName"
                    v-model="search.ooptType"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                    @change="ooptListData"
                  />
                </div>
              </v-col>
              <v-col>
                <v-label>{{ $t('Область') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="refSoates"
                    item-value="id"
                    item-text="fullTransName"
                    v-model="search.region"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                    @change="ooptListData"
                  />
                </div>
              </v-col>
              <v-col>
                <v-label>{{ $t('Организация') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="oopts"
                    item-value="id"
                    item-text="transName"
                    v-model="search.oopt"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
              <v-col>
                <v-label>{{ $t('Вид животного') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="faunas"
                    item-value="id"
                    item-text="transName"
                    v-model="search.fauna"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
            </v-row>
            <div class="search-action">
              <button
                class="btn btn-default green-grassy"
                @click="getLimitListByYear()"
              >
                {{ $t('Поиск') }}
              </button>
              <button
                class="btn btn-default gray"
                @click="search = {}, getLimitListByYear()"
              >
                {{ $t('Очистить') }}
              </button>
            </div>
          </div>
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td class="td-num">№</td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Охотпользователь') }}
                    <a @click="sort('oopt')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'oopt' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Вид животного') }}
                    <a @click="sort('fauna')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'fauna' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>{{ $t('Норматив пользования %') }}</td>
                <td>{{ $t('Кол-во голов') }}</td>
                <td>{{ $t('Дата расчета') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(limit, i) in limits" :key="i">
                <td class="td-num">{{ i + 1 }}</td>
                <td>{{ limit.oopt }}</td>
                <td>{{ limit.fauna }}</td>
                <td>{{ limit.usageStandard }}</td>
                <td>{{ limit.headQuantity }}</td>
                <td>{{ new Date(limit.updatedDate) | dateFormat('DD.MM.YYYY') }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <v-pagination
            v-model="page"
            :length="paginationData.pageCount"
            total-visible="10"
          />
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Limit from '@/model/limit'
import { mapMutations } from 'vuex'
import Menu from '@/components/quota/Menu'

export default {
  components: {
    Menu
  },
  data: () => ({
    page: 1,
    paginationData: {},
    breadcrumbs: [],
    refYear: [],
    yearId: null,
    faunas: [],
    refSoates: [],
    ooptTypes: [],
    oopts: [],
    limits: [],
    sortParams: {
      field: 'oopt',
      order: 'ASC'
    },
    search: {}
  }),
  mounted () {
    this.fetchData()
  },
  watch: {
    page () {
      this.getLimitListByYear(false)
    },
    yearId () {
      this.getLimitListByYear()
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Limit.getFormData()
        .then((res) => {
          this.refYear = res.data.refYear
          this.faunas = res.data.faunas
          this.refSoates = res.data.refSoates
          this.ooptTypes = res.data.ooptTypes
          const currentYear = new Date().getFullYear()
          this.refYear.forEach((e) => {
            if (+e.year === currentYear) this.yearId = e.id
          })
          this.ooptListData()
          this.setLoading(false)
        })
        .catch((err) => {
          console.log(err)
          this.setLoading(false)
        })
      this.generateBreadcrumbs()
    },
    ooptListData () {
      if (!this.search.region) {
        this.oopts = []
        delete this.search.oopt
        return
      }
      Limit.getOoptDataBySoateAndType(this.search.region, this.search.ooptType)
        .then((res) => {
          this.oopts = res.data.oopts
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getLimitListByYear (resetPage = true) {
      this.setLoading(true)
      if (resetPage) this.page = 1
      this.search.page = this.page
      this.search.sortField = this.sortParams.field
      this.search.sortOrder = this.sortParams.order
      Limit.getLimitListByYear(this.yearId, this.search)
        .then((res) => {
          this.limits = res.data.items
          this.paginationData = res.data.paginationData
          this.setLoading(false)
        })
        .catch((err) => {
          this.setLoading(false)
          console.log(err)
        })
    },
    sort (field) {
      this.sortParams.field = field
      this.sortParams.order = this.sortParams.order === 'ASC' ? 'DESC' : 'ASC'

      this.getLimitListByYear()
    },
    changeYear (id) {
      this.yearId = id
    },
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Лимиты'),
          disabled: true
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
